import { Component } from 'react';

import { creditCardExpiryFilter } from '../../utils/creditCardFilters';
import Field from '../forms/Field';
import TextInput from '../inputs/DeprecatedTextInput';

interface Props {
  autoComplete?: boolean;
  'data-testid'?: string;
  disabled?: boolean;
  field: ReduxFormField<string>;
  label?: string;
  id?: string;
}

/**
 * @deprecated Prefer a Pantry component instead. See https://docs.tocktix.com/pantry.
 * If an equivalent component doesn't exist yet, reach out in #pantry-design-system on Slack.
 */
export default class CreditCardExpiryInput extends Component<Props> {
  render() {
    const { autoComplete, disabled, field, label, id } = this.props;

    return (
      <Field field={field} label={label} labelFor={id}>
        <TextInput
          autoComplete={autoComplete ? 'cc-exp' : 'off'}
          disabled={disabled}
          data-testid={this.props['data-testid']}
          field={field}
          filter={creditCardExpiryFilter}
          maxLength={7}
          pattern="\d*"
          type="tel"
          placeholder="MM / YY"
          id={id}
        />
      </Field>
    );
  }
}
